/* ---------------------------------------------------------------------------
   Course artwork.

   Where a course has no photograph and none exists in any source, it gets a
   drawing rather than a grey box or a borrowed picture of something else.
   These are deliberately illustrations — nobody will mistake one for a
   photograph of the department — and they use the site palette so they sit
   quietly beside the real photographs on the same page.

   Composition is centred and the SVG is sliced, so the same drawing works in
   a square tile and a 4:3 one. Replace a drawing by adding the course to
   COURSE_SHOT in src/data/imagery.js — the photograph wins.
--------------------------------------------------------------------------- */

const Optometry = () => (
  <svg
    className="course-art"
    viewBox="0 0 400 400"
    preserveAspectRatio="xMidYMid slice"
    role="img"
    aria-label="Illustration of an eye chart and a trial frame"
  >
    <defs>
      <linearGradient id="opt-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#eaf2fd" />
        <stop offset="100%" stopColor="#cfe0f6" />
      </linearGradient>
      <linearGradient id="opt-lens" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.95" />
        <stop offset="100%" stopColor="#bcd8f4" stopOpacity="0.85" />
      </linearGradient>
    </defs>

    <rect width="400" height="400" fill="url(#opt-bg)" />

    {/* quiet ground: a lens-shaped arc and the concentric rings of a target */}
    <circle cx="320" cy="80" r="120" fill="#0b63ce" opacity="0.07" />
    <g stroke="#0b63ce" opacity="0.16" fill="none">
      <circle cx="318" cy="318" r="86" strokeWidth="2" />
      <circle cx="318" cy="318" r="60" strokeWidth="2" />
      <circle cx="318" cy="318" r="34" strokeWidth="2" />
    </g>

    {/* Everything lives between y=70 and y=335 so the drawing reads whole
        whether the slot crops it to a square or to 4:3. */}

    {/* the Snellen chart — the one object everyone recognises */}
    <g>
      <rect x="58" y="74" width="180" height="182" rx="12" fill="#ffffff" opacity="0.96" />
      <g fill="#10214b" textAnchor="middle" fontFamily="Georgia, serif" fontWeight="700">
        <text x="140" y="126" fontSize="40">E</text>
        <text x="140" y="166" fontSize="27" letterSpacing="6">F P</text>
        <text x="140" y="198" fontSize="20" letterSpacing="5">T O Z</text>
        <text x="140" y="224" fontSize="14" letterSpacing="4">L P E D</text>
        <text x="140" y="244" fontSize="10" letterSpacing="3">P E C F D</text>
      </g>
      {/* the measured line down the side of every chart */}
      <line x1="224" y1="110" x2="224" y2="248" stroke="#0b63ce" strokeWidth="2" opacity="0.38" />
      {[114, 158, 192, 220, 242].map((y) => (
        <line key={y} x1="218" y1={y} x2="230" y2={y} stroke="#0b63ce" strokeWidth="2" opacity="0.38" />
      ))}
    </g>

    {/* the trial frame, overlapping the chart the way it does in a clinic */}
    <g transform="translate(96 244)">
      <rect x="66" y="18" width="40" height="8" rx="4" fill="#10214b" />
      <circle cx="48" cy="22" r="40" fill="url(#opt-lens)" stroke="#10214b" strokeWidth="6" />
      <circle cx="124" cy="22" r="40" fill="url(#opt-lens)" stroke="#10214b" strokeWidth="6" />
      {/* the dial that changes the lens, in the group's saffron */}
      <circle cx="48" cy="22" r="15" fill="none" stroke="#f47920" strokeWidth="4.5" />
      <line x1="48" y1="7" x2="48" y2="0" stroke="#f47920" strokeWidth="4.5" strokeLinecap="round" />
      <path d="M4,8 L-22,-6" stroke="#10214b" strokeWidth="6" strokeLinecap="round" />
      <path d="M168,8 L194,-6" stroke="#10214b" strokeWidth="6" strokeLinecap="round" />
    </g>
  </svg>
);

const COURSE_ART = {
  "bsc-optometry": <Optometry />,
};

export default COURSE_ART;
